import moment from 'moment';
/* 所有数字美化 */
/**
 * 千位数字逗号分隔
 * @param {*} num
 * @returns
 */
function thousandSeperate(num) {
  const numArr = num
    .toString()
    .split('')
    .reverse();
  for (let i = 0, j = 0; i < numArr.length; i++) {
    if (j === 3) {
      j = 0;
      numArr.splice(i, 0, ',');
      i++;
    }
    j++;
  }
  return numArr.reverse().join('');
}

/* million
 * 过万处理
 * @param num
 * @returns {string}
 */

function million(num) {
  if (num != null && !isNaN(num)) {
    if (Number.isNaN(num)) {
      return '-';
    }
    num = Number(num);
    if (num < 10000) {
      return num;
    } if (num >= 10000 && num < 1000000) {
      return `${(num / 10000).toFixed(1)}万`;
    } if (num >= 1000000 && num < 100000000) {
      return `${(num / 10000).toFixed(0)}万`;
    } if (num >= 100000000 && num < 10000000000) {
      return `${(num / 100000000).toFixed(1)}亿`;
    } if (num >= 10000000000) {
      return `${(num / 100000000).toFixed(0)}亿`;
    }
  } else {
    return '-';
  }
}
/* millionNotUnit
 * 过万处理（不加单位）
 * @param num
 * @returns {string}
 */

function millionNotUnit(num) {
  if (num != null && !isNaN(num)) {
    if (Number.isNaN(num)) {
      return '-';
    }
    num = Number(num);
    if (num < 10000) {
      return num;
    } if (num >= 10000 && num < 1000000) {
      return (num / 10000).toFixed(1);
    } if (num >= 1000000 && num < 100000000) {
      return (num / 10000).toFixed(0);
    } if (num >= 100000000 && num < 10000000000) {
      return (num / 100000000).toFixed(1);
    } if (num >= 10000000000) {
      return (num / 100000000).toFixed(0);
    }
  } else {
    return '-';
  }
}

/* millionNumber
 * 帮助人次
 * 过万处理（只数字带小数）
 * @param num
 * @returns {Number}
 */
function millionNumberOther(num) {
  if (num != null && !isNaN(num)) {
    if (Number.isNaN(num)) {
      return '-';
    }
    num = Number(num);
    if (num < 10000) {
      return num;
    } if (num >= 10000 && num < 1000000) {
      return Number(this.toNumFixed(num / 10000, 1));
    } if (num >= 1000000 && num < 100000000) {
      return Number(this.toNumFixed(num / 10000, 0));
    } if (num >= 100000000 && num < 10000000000) {
      return Number(this.toNumFixed(num / 100000000, 1));
    } if (num >= 10000000000) {
      return Number(this.toNumFixed(num / 100000000, 1));
    }
  } else {
    return '-';
  }
}

/* millionNumber
 * 柱状图使用
 * 过万处理（只数字）
 * @param num
 * @returns {Number}
 */
function millionNumber(num) {
  if (num != null && !isNaN(num)) {
    if (Number.isNaN(num)) {
      return '-';
    }
    num = Number(num);
    if (num < 10000) {
      return num;
    } if (num >= 10000 && num < 1000000) {
      return Number(this.toNumFixed(num / 10000, 1) * 10000);
    } if (num >= 1000000 && num < 100000000) {
      return Number(this.toNumFixed(num / 10000, 0) * 10000);
    } if (num >= 100000000 && num < 10000000000) {
      return Number(this.toNumFixed(num / 100000000, 1) * 100000000);
    } if (num >= 10000000000) {
      return Number(this.toNumFixed(num / 100000000, 1) * 100000000);
    }
  } else {
    return '-';
  }
}

/* millionUnit
 * 过万处理（只单位）
 * @param num
 * @returns {string}
 */
function millionUnit(num) {
  if (num != null && !isNaN(num)) {
    if (Number.isNaN(num)) {
      return '';
    }
    num = Number(num);
    return num >= 100000000 ? '亿' : num >= 10000 ? '万' : '';
  }
  return '';
}

/**
 * 指数格式化
 * @param num
 * @param precision
 * @returns {number}
 */
function preciseNum(num, precision = 0) {
  if (num != null && !isNaN(num)) {
    if (Number.isNaN(num)) {
      return '-';
    }
    if (precision === 1) {
      num = Number(this.toNumFixed(num, 1));
      if (num % 1 === 0) {
        return Number(this.toNumFixed(num, 0));
      }
      return num;
    } if (precision === 2) {
      num = Number(this.toNumFixed(num, 2));
      if (num % 1 === 0) {
        return Number(this.toNumFixed(num, 0));
      }
      return num;
    }
    return Number(this.toNumFixed(num, 0));
  }
  return '-';
}

/**
 * 时间美化
 * @param time
 * @returns {number}
 */
function timeConversion(time) {
  if (time != null && !isNaN(time)) {
    if (Number.isNaN(time)) {
      return '-';
    }
    if (time < 60) {
      return time;
    }
    return parseFloat(this.toNumFixed(time / 60, 1));
  }
  return '-';
}
/**
 * toFixed四舍五入精度的代替函数
 * @param num 需要四舍五入的小数
 * @param s 需要保留几位小数
 * @returns {number}
 */
function toNumFixed(num, s) {
  const times = Math.pow(10, s);
  let dec = num * times + 0.5;
  dec = parseInt(dec, 10) / times;
  return `${dec}`;
}

/**
 * 判断是否为昨天
 * 柱状图使用
 * @param time
 * @returns {number}
 */
function isYesterday(time) {
  let oldDay = moment()
    .subtract(1, 'days')
    .format('YYYY-MM-DD');
  oldDay = moment(oldDay).valueOf() / 1000;
  if (time === oldDay) {
    return '昨日';
  }
  return moment(time * 1000).format('MM.DD');
}

/**
 * 时间转为小时保留1位
 * @param time
 * @returns {number}
 */
function handleTimeConversion(time) {
  return Number(this.toNumFixed(time / 60, 1));
}

export default {
  thousandSeperate,
  million,
  millionNotUnit,
  millionNumber,
  millionNumberOther,
  millionUnit,
  preciseNum,
  timeConversion,
  toNumFixed,
  isYesterday,
  handleTimeConversion
};
